import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PilotlyIcon from "../../assets/pilotly-logo-symbol.svg";
import PeacockAvatar from "../../assets/peacock-avatar-real.png";
import PeacockLogo from '../../assets/svod/peacock.png';
import PeacockLogoWhite from '../../assets/svod/peacock-logo-white.png';

import {
	faUser,
	faMagnifyingGlass,
	faWandMagicSparkles,
	faHouseChimney,
	faClapperboard,
	faTv,
	faHeart,
	faFootball,
	faPlus,
} from '@fortawesome/free-solid-svg-icons';

class SVODSideMenu extends React.Component {
	// open/close menu logic may not be needed
	// test out handle it
	constructor(props) {
		super(props);

		this.state = {
			sideMenuOpenClass: ""
		};

		this.handleOpenMenu = this.handleOpenMenu.bind(this);
		this.handleCloseMenu = this.handleCloseMenu.bind(this);
	}

	handleCloseMenu() {
		if (this.state.sideMenuOpenClass) {
			this.setState({ sideMenuOpenClass: "" });
		}
	}

	handleOpenMenu() {
		if (!this.state.sideMenuOpenClass) {
			this.setState({ sideMenuOpenClass: "menu-open" });
		}
	}

	render() {
		const { sideMenuOpenClass } = this.state;
		const { addedClasses, profileIconOnly } = this.props;

		const profileIcon = (
			<Link to="/study" id="profile-to-home-icon">
				<div className="profile-icon-wrapper">
					<div className="profile-icon">
						<img src={PeacockAvatar} />
					</div>
					<span>Pilotly User</span>
				</div>
			</Link>
		);

		if (profileIconOnly) {
			return (
				<div className={`svod-side-menu ${addedClasses || ""} ${sideMenuOpenClass} `}
					onClick={() => this.handleOpenMenu()}>
					{profileIcon}
				</div>
			);
		}

		return (
			<div className={`svod-side-menu ${addedClasses || ""} ${sideMenuOpenClass}`}
				onClick={() => this.handleOpenMenu()}>
				{profileIcon}

				<div className="svod-side-menu-icons">
					<div className="icons-wrapper">
						<FontAwesomeIcon className="menu-icon-closed" icon={faMagnifyingGlass} />
						<FontAwesomeIcon className="menu-icon-closed" icon={faHouseChimney} />
						<FontAwesomeIcon className="menu-icon-closed" icon={faClapperboard} />
						<FontAwesomeIcon className="menu-icon-closed" icon={faTv} />
						<FontAwesomeIcon className="menu-icon-closed" icon={faFootball} />
						<FontAwesomeIcon className="menu-icon-closed" icon={faHeart} />
						<FontAwesomeIcon className="menu-icon-closed" icon={faPlus} />
					</div>
				</div>

				<div className="svod-side-full-menu" onClick={() => this.handleCloseMenu()}>
					<div className="full-menu-icons-wrapper">
						<div className="menu-option-wrapper search-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faMagnifyingGlass} />
							Search
						</div>
						<div className="menu-option-wrapper home-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faHouseChimney} />
							Home
						</div>
						<div className="menu-option-wrapper movie-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faClapperboard} />
							Movies
						</div>
						<div className="menu-option-wrapper tv-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faTv} />
							TV Shows
						</div>
						<div className="menu-option-wrapper sports-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faFootball} />
							Sports
						</div>
						<div className="menu-option-wrapper wwe-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faHeart} />
							WWE
						</div>
						<div className="menu-option-wrapper my-stuff-icon">
							<FontAwesomeIcon className="menu-icon-open" icon={faPlus} />
							My Stuff
						</div>
					</div>
				</div>

				<div className="peacock-branding-wrapper">
					<Link to="/study"><img className="peacock-logo-icon" src={PeacockLogo} /></Link>
					<Link to="/study"><img className="peacock-logo-icon-full" src={PeacockLogoWhite} /></Link>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SVODSideMenu));


// WEBPACK FOOTER //
// ./src/components/svod/SVODSideMenu.js